var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.9067 34.774H29.6155V27.5542H27.9044L27.9067 34.774ZM32.6067 34.774H34.3178V27.5542H32.6067V34.774ZM6.15333 10.4432H29.4022V8.23536H6.15333V10.4432ZM31.1111 40C28.6356 40 26.5356 39.1426 24.8111 37.4278C23.0852 35.713 22.2222 33.6259 22.2222 31.1663C22.2222 28.7067 23.0852 26.6196 24.8111 24.9048C26.537 23.19 28.637 22.3334 31.1111 22.3348C33.5852 22.3363 35.6859 23.1929 37.4133 24.9048C39.1407 26.6166 40.003 28.7038 40 31.1663C40 33.6244 39.1378 35.7108 37.4133 37.4256C35.6859 39.1404 33.5852 39.9978 31.1111 39.9978M0 37.0238V0H35.5555V16.6915C35.1941 16.559 34.8356 16.4457 34.48 16.3515C34.123 16.2573 33.7407 16.1837 33.3333 16.1307V2.20787H2.22222V33.2285H16.32C16.4207 33.8319 16.5511 34.4222 16.7111 34.9992C16.8726 35.5762 17.097 36.1267 17.3844 36.6507L17.3089 36.7257L14.7867 34.902L11.7956 37.0238L8.80444 34.902L5.81333 37.0238L2.82 34.902L0 37.0238ZM6.15555 27.0884H16.62C16.703 26.6836 16.8052 26.3046 16.9267 25.9513C17.0481 25.5981 17.1904 25.2411 17.3533 24.8805H6.15555V27.0884ZM6.15555 18.7669H22.4C23.1259 18.1973 23.9037 17.7226 24.7333 17.3428C25.563 16.9616 26.4496 16.7003 27.3933 16.559H6.15333L6.15555 18.7669Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAc);
export default __webpack_public_path__ + "static/media/AC.b1a8b2c6b4e90b3adc41a3a7066610b8.svg";
export { ForwardRef as ReactComponent };